import React from 'react';

const CollapseIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24">
    <path d="M21 3v18H3v-9.133h2V19h14V5h-7V3h9zm-16.293.293L11 9.586V8h2v5H8v-2h1.586L3.293 4.707l1.414-1.414z" />
  </svg>
);

export default CollapseIcon;
